/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<ObjectMap>;
export function request(params: API.basics.certMain.list.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/certMain/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
